// components/tracking/ConsentBasedTracking.tsx
'use client'

import { useConsent } from '@/app/contexts/ConsentContext';
import MetaPixel from './MetaPixel';
// import GoogleAds from './GoogleAds'; // Diese Zeile entfernen!

/**
 * Rendert Tracking-Komponenten, die AKTIV Daten senden (z.B. Events),
 * basierend auf dem Consent-Status.
 * Die Basis-Bibliotheken (gtag.js, etc.) werden im RootLayout geladen.
 */
export default function ConsentBasedTracking() {
  const { isInitialized, consents } = useConsent();

  // Warten, bis der Consent-Status bekannt ist
  if (!isInitialized) {
    console.log('[ConsentBasedTracking] Waiting for consent initialization...');
    return null;
  }

  console.log('[ConsentBasedTracking] Initialized. Marketing Consent:', consents.marketing);

  return (
    <>
      {/* Nur Marketing-relevante Tracking-Komponenten rendern, wenn Consent gegeben ist */}
      {consents.marketing && (
        <>
          {/* Meta Pixel Komponente (stellt sicher, dass sie nur Events sendet, nicht die Lib lädt) */}
          <MetaPixel />

          {/* Hier könnten Komponenten für spezifische Google Ads Events (z.B. Conversions) stehen */}
          {/* Beispiel: <GoogleAdsPurchaseEvent /> */}

          {/* Log nur zur Bestätigung */}
          {/* console.log('[ConsentBasedTracking] Rendering components for Marketing consent.'); */}
        </>
      )}
      {/* Optional: Andere Consent-Typen behandeln */}
      {/* {consents.analytics && <AnalyticsEventComponent />} */}
    </>
  );
}